<template>
  <div style="padding: 10px;">
    <div class="mySpinner" v-if="isLoading">
        <Spinner style="width: 100%; position: fixed;"></Spinner>
    </div>
    <Modal :showDialog="selectedImage != null" @close="() => selectedImage = null" style="justify-content: center; display: flex; flex-direction: column;">
        <img :src="selectedImage != null ? selectedImage.url : ''" style="max-width: 70vw; max-height: 70vh; margin-top: 5px;">
    </Modal>
    <div v-if="ticketStatus != 2 && ticketStatus != 4" style="text-align: end;">
      <Button :title="$t('CloseTicket')" buttonClass='delete-button semi-bold' style="width: 100px;" @onClick="confirmRequestToClose"></Button>
    </div>
    <div id="messagesList" ref="messagesList" :style="computedHeight" style="overflow-y: scroll; height: calc(100vh - 170px);" class="style-2" >
        <div v-for="mes in messages" :key="mes.Id" :class='["vertical", { message: !mes.isEvent }, {rightside: mes.creatorId != $store.getters.user.userId}]'>
            <div v-if="mes.isEvent" style="width: 100%; text-align: center; margin: 10px 0;">
                <span style="text-align: center;" class="date"> {{ mes.content }}</span>
            </div>
            <div v-else-if="mes.creatorId != $store.getters.user.userId">
                <span :class='["date", "rightside"]' style="float: left; margin-right: 10px;">{{ mes.sentDate }}</span>
                <span :class='["date", "rightside"]' style="font-weight: bold;"> {{ mes.creatorName }} </span>
            </div>
            <div v-else>
                <span :class='["date"]' style="font-weight: bold;"> {{ mes.creatorName }} </span>
                <span :class='["date"]' style="float: right; margin-left: 10px;">{{ mes.sentDate }}</span>
            </div>
            <div v-if="!mes.isEvent" style="text-wrap: wrap; overflow-wrap: anywhere;">
                <span>{{ mes.content }}</span>
            </div>
            <div :class='["horizontal", { "img-right": mes.creatorId != $store.getters.user.userId}]' style="flex-wrap: wrap;">
                <div v-for="(img, i) in mes.photos" :key="i" @click="showImage(img)" style="align-self: center; margin: 1px;">
                    <img :src="img.url" style="height: 60px; width: 60px; cursor: pointer; object-fit: cover;">
                </div>
            </div>
        </div>
    </div>
    <div v-if="ticketStatus == 2" style="display: flex; justify-content: center;">
        <div style="display: flex; flex-direction: column; justify-content: center; width: 80%; background-color: #414F51; color: white; border-radius: 5px; padding: 10px;">
            <h3 style="text-align: center;">Requested To Close</h3>
            <div class="horizontal" style="justify-content: space-around;">
                <div class="action-button green" @click="confirmRequestToClose">
                    Accept
                </div>
                <div class="action-button red" @click="denyRequestToClose">
                    Deny
                </div>
            </div>
        </div>
    </div>
    <div class="thumbnails horizontal">
        <div v-for="(photo, index) in photos" :key="index">
            <div class="thumbnail-container">
                <img class="delete-image" style="cursor: default;" src="~@/assets/img/Visits/Delete.svg" @click="deletePhoto(index)">
                <img :src="photo.url" class="thumbnail"/>
            </div>
        </div>
    </div>
    <div v-if="!isClosed" class="horizontal" style="align-items: center;">
        <div @click="openPhotoSelect" class="attach-images">
            <img src="~@/assets/img/Systems/Attach.svg" />
            <input id="file-chooser" style="display: none;" type="file" name="file" accept="image/*" multiple @change.prevent="photoChange"/>
        </div>
        <textarea v-model="newMessage" @keyup="sendMessageKey" class="new-message"></textarea>
        <Button :title="$t('Send')" buttonClass='save-button semi-bold' style="width: 100px; align-self: center; margin: 10px;" @onClick="sendMessage"></Button>
    </div>
    <div style="justify-content: center; margin-bottom: 10px;"  class="horizontal">
        <div class="error" v-if="error != ''">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { getMessagesForTicket, getMessageResource, sendMessage, readTicket, confirmRequestToClose, denyRequestToClose } from '@api'
import Button from '@/components/Button'
import moment from 'moment';
import Modal from '@/components/Modal'
import Spinner from 'vue-simple-spinner'
import Vue from 'vue'

export default {
    components: {
        Button,
        Modal,
        Spinner
    },
    props: {
        ticketId: {
            required: true,
            type: String
        },
        isClosed: {
            required: true,
            type: Boolean
        }
    },
    computed: {
        computedHeight() {
            var value = 170;
            if(this.ticketStatus == 2) {
                value += 100;
            } else if (this.ticketStatus != 4) {
                value += 35;
            }

            if (this.photos.length != 0) {
                value += 80;
            }

            return `height: calc(100vh - ${value}px) !important;`
        }
    },
    data() {
        return {
            messages: [],
            selectedImage: null,
            newMessage: '',
            error: '',
            photos: [],
            isLoading: false,
            ticketStatus: 0
        }
    },
    watch: {
        ticketId(newValue, oldValue) {
            this.getData();
        }
    },
    methods: {
        async getData() {
            this.isLoading = true

            var result = await getMessagesForTicket(this.ticketId);
            this.ticketStatus = result.status;

            result.messages.sort((a, b) => new Date(a.sentDate) - new Date(b.sentDate))

            result.messages.forEach((e) => {
                e.sentDate = moment(e.sentDate).format(this.isToday(e.sentDate) ? "HH:mm" : "YYYY-MM-DD, HH:mm")
            })

            for(let i = 0; i < result.messages.length; i++) {
                result.messages[i].photos = [];
            }
            this.messages = result.messages;
            this.isLoading = false;

            await readTicket(this.ticketId);

            await this.getImages(result);
            this.messages = result.messages;

            Vue.nextTick(function () {
                document.getElementById('messagesList').scrollTop = document.getElementById('messagesList').scrollHeight;
            })
        },
        async getImages(result) {
            for(let i = 0; i < result.messages.length; i++) {
                result.messages[i].photos = []
                for(let j = 0; j < result.messages[i].resources.length; j++) {
                  if (result.messages[i].resources[j] != null) {
                    var res = await getMessageResource(result.messages[i].resources[j])
                    let photo = URL.createObjectURL(new Blob([res.data], {
                      type: res.headers['content-type']
                    })
                    );
                    result.messages[i].photos.push({
                      src: res,
                      url: photo
                    })
                  }
                }
            }
        },
        async confirmRequestToClose(){
            await confirmRequestToClose(this.ticketId);
            await this.getData();
        },
        async denyRequestToClose() {
            await denyRequestToClose(this.ticketId);
            await this.getData();
        },
        showImage(img) {
            this.selectedImage = img
        },
        isToday(someDate) {
            const otherDate = new Date(someDate);
            const today = new Date()
            return otherDate.getDate() == today.getDate() &&
                otherDate.getMonth() == today.getMonth() &&
                otherDate.getFullYear() == today.getFullYear()
        },
        async sendMessage() {
            this.error = ''

            if(this.newMessage == null || this.newMessage == ''){
                this.error = 'Cannot send empty message'
                return
            }

            var toSend = {}
            toSend.ticketId = this.ticketId;
            toSend.content = this.newMessage;

            var form = new FormData()
            var keys = Object.keys(toSend)
            for(let i = 0; i < keys.length; i++){
                form.append(keys[i], toSend[keys[i]])
            }

            var photosSrc = this.photos.map(x => x.src)
            for(let i = 0; i < photosSrc.length; i++) {
                form.append("resources", photosSrc[i])
            }

            await sendMessage(form)
            this.newMessage = ''
            this.photos = []
            this.getData()
        },
        sendMessageKey(args) {
            if(args.key == 'Enter') {
                this.sendMessage()
            }
        },
        deletePhoto(index) {
            this.photos.splice(index, 1);
        },
        photoChange(e) {
            for(let i = 0; i < e.target.files.length; i++ ) {
                var photo = URL.createObjectURL(e.target.files[i]);
                this.photos.push({
                    src: e.target.files[i],
                    url: photo
                });
            }
        },
        openPhotoSelect() {
            document.getElementById('file-chooser').click()
        },
    },
    async mounted() {
        this.getData()
    }
}
</script>

<style scoped>
.message {
    border-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 0;
    padding: 1rem;
    width: fit-content;
    max-width: 80%;
    background: #b9d8e0;
    font-size: 14px;
}

.message.rightside {
    margin-left: auto;
    text-align: end;
    margin-right: 5px;
    background: #007c95;
    color: white;
}

.message + .message {
    margin-top: 1rem;
}

.date {
    color: slategrey;
}

.rightside {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 10px;
}

.date.rightside {
    color: rgb(230, 230, 230);
}

.img-right {
    justify-content: right;
}

.title {
    font-weight: bold;
    font-size: 14px;
    margin: 0px;
}

.bigger-height {
    height: calc(100vh - 250px) !important;
}

.input {
    /* height: 35px; */
    border: 1px solid #A3D4E0;
    border-radius: 5px;
    color: black;
    padding: 10px;
    width: 100%;
}

input::placeholder {
    color: rgb(0, 149, 178);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.new-message {
    width: 90%;
    height: 50px;
    max-height: 200px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.attach-images {
    cursor: pointer;
}

.attach-images:hover {
    transition: 0.1s;
    background: #eee;
    border-radius: 5px;
    border: 1px solid #eee;
}
</style>

<style scoped>
.thumbnails {
    margin: unset;
}

.action-button {
    border: solid 4px;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
    width: 100px;
    text-align: center;
}

.action-button.green {
    border-color: green;
}

.action-button.red {
    border-color: red;
}

.action-button.red:hover {
    transition-duration: 0.2s;
    background-color: red;
}

.action-button.green:hover {
    transition-duration: 0.2s;
    background-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/Tickets/MessagesModal.vue